import { render, staticRenderFns } from "./SoftFairStammdaten.vue?vue&type=template&id=4e37f243&"
import script from "./SoftFairStammdaten.vue?vue&type=script&lang=js&"
export * from "./SoftFairStammdaten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports